import React, { useState } from 'react'

import { defaultCard } from 'types/deck'
import { GlobalColorTag } from 'services/apiTypes/colorTag.types'

import { useActions, useAppSelector } from 'redux/hooks'
import { setDeckStateAction } from 'redux/deck/actions'

import SaveService from 'services/save.service'

import PhatButton from 'components/formElements/PhatButton'
import GlobalColorTags from 'components/deckPage/settings/forms/ColorTags/GlobalColorTags'
import ColorTagEditModal from 'components/misc/ColorTagEditModal'
import ColorTagTable from 'components/misc/ColorTagTable'
import Icon from 'components/elements/Icon'

import styles from './colorTagSettings.module.scss'

/**
 * Settings for managing a decks color tags. This components children can be used to
 * create/ and delete color tags for decks.
 */
const ColorTagSettings = () => {
  const [creatingNewTag, setCreatingNewTag] = useState(false)

  const [setDeckState] = useActions(setDeckStateAction)

  const colorLabels = useAppSelector(state => state.deck.colorLabels)
  const cardMap = useAppSelector(state => state.deck.cardMap)

  const handleDeleteColorTag = ({ name }: GlobalColorTag) => {
    const cardsToUpdate = Object.values(cardMap).filter(card => card.colorLabel.name === name)
    const updatedCards = cardsToUpdate.map(c => ({ ...c, colorLabel: defaultCard.colorLabel }))

    SaveService.save(updatedCards).then(() => {
      setDeckState({ colorLabels: colorLabels.filter(label => label.name !== name) })
    })
  }

  const handleSetAllColorTags = ({ name }: GlobalColorTag) => {
    const colorTag = colorLabels.find(tag => tag.name === name) || defaultCard.colorLabel

    SaveService.save(Object.values(cardMap).map(card => ({ ...card, colorLabel: colorTag })))
  }

  // TODO - fix this if someone edits the name, cause it'll break
  const handleUpdateTag = ({ name, color }: GlobalColorTag) => {
    const updatedLabel: GlobalColorTag = { name, color }

    const cardsToUpdate = Object.values(cardMap).filter(card => card.colorLabel.name === name)
    const updatedColorLabels = colorLabels.map(label => (label.name === name ? updatedLabel : label))

    const updatedCards = cardsToUpdate.map(c => ({ ...c, colorLabel: updatedLabel }))

    SaveService.save(updatedCards).then(() => {
      setDeckState({ colorLabels: updatedColorLabels })
    })
  }

  const handleTagCreation = (tag: GlobalColorTag) =>
    setDeckState({ colorLabels: [...colorLabels, { name: tag.name, color: tag.color }] })

  return (
    <div className={styles.container}>
      <h4>Deck color tags</h4>

      <ColorTagTable
        usedInOverlay
        usedOnDeckPage
        noEditOnDefaults
        tags={colorLabels}
        onSetAll={handleSetAllColorTags}
        onEdited={handleUpdateTag}
        onRemovedFromDeck={handleDeleteColorTag}
      />

      <div className={styles.controls}>
        <PhatButton color="green" onClick={() => setCreatingNewTag(true)}>
          <Icon name="add" /> New color tag
        </PhatButton>
      </div>

      <ColorTagEditModal
        usedInOverlay
        open={creatingNewTag}
        onClose={() => setCreatingNewTag(false)}
        onEdit={handleTagCreation}
      />

      <GlobalColorTags />
    </div>
  )
}

export default ColorTagSettings
